 
import { useEffect } from 'react';
const ImportScript = username => {
  useEffect(() => {
    let script = document.createElement("script");
    script.type="text/javascript";
    script.innerHTML="var _smartsupp = _smartsupp || {};   _smartsupp.key = '785b2e7d2864b78d1be168605761a8a1cb3d513a';   window.smartsupp||(function(d) {  var s,c,o=smartsupp=function(){ o._.push(arguments)};o._=[]; s=d.getElementsByTagName('script')[0];c=d.createElement('script');c.type='text/javascript';c.charset='utf-8';c.async=true;c.src='https://www.smartsuppchat.com/loader.js?';s.parentNode.insertBefore(c,s);})(document);";
    document.getElementsByTagName('head')[0].appendChild(script);
  
    let config = document.createElement("script");
    config.innerHTML=`smartsupp('name', '${username}');`;
    document.getElementsByTagName('head')[0].appendChild(config);

  
    document.getElementsByTagName('title')[0].innerHTML = 'Mybudapester - Manager';

return () => {}
  }, [username]);
};
export default ImportScript;